module.exports = __webpack_public_path__ + "img/logo.3022ff1d.png";